"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransitionManagerExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'utils/transition-manager/examples/index.ts';
var TransitionManagerExample = /** @class */ (function () {
    function TransitionManagerExample() {
        var _this = this;
        this.isDialogOpen = false;
        this.closeDialog = function () { return _this.isDialogOpen = false; };
    }
    TransitionManagerExample.prototype.onremove = function () {
        _1.TransitionManager.isEnabled = true;
    };
    TransitionManagerExample.prototype.view = function () {
        var _this = this;
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.ButtonGroup, [
                (0, mithril_1.default)(_1.Popover, {
                    content: 'Content',
                    trigger: (0, mithril_1.default)(_1.Button, { label: 'Popover trigger' })
                }),
                (0, mithril_1.default)(_1.Tooltip, {
                    content: 'Content',
                    trigger: (0, mithril_1.default)(_1.Button, { label: 'Tooltip trigger' })
                }),
                (0, mithril_1.default)(_1.Button, {
                    label: 'Show dialog',
                    onclick: function () { return _this.isDialogOpen = !_this.isDialogOpen; }
                })
            ]),
            (0, mithril_1.default)(_1.Dialog, {
                content: 'Content',
                isOpen: this.isDialogOpen,
                onClose: this.closeDialog,
                title: 'Dialog title',
                footer: (0, mithril_1.default)(".".concat(_1.Classes.ALIGN_RIGHT), [
                    (0, mithril_1.default)(_1.Button, {
                        label: 'Close',
                        onclick: this.closeDialog
                    })
                ])
            })
        ]);
    };
    TransitionManagerExample.prototype.renderOptions = function () {
        return [
            (0, mithril_1.default)(_1.Switch, {
                label: 'Enabled',
                checked: _1.TransitionManager.isEnabled,
                onchange: function () {
                    _1.TransitionManager.isEnabled
                        ? _1.TransitionManager.disable()
                        : _1.TransitionManager.enable();
                }
            })
        ];
    };
    return TransitionManagerExample;
}());
exports.TransitionManagerExample = TransitionManagerExample;
